import styled from "styled-components";

export const Container = styled.div`
  width: 1200px;
  margin: 0 auto;
  padding: 0 50px;
  @media screen and (max-width: 480px) {
    width: 100%;
    margin: 0;
    padding: 0;
  }
`;
